import { ACTION_PRODUCT_SWITCH_COMPOSITION } from './action-types';
import difference from 'lodash/difference';
import intersection from 'lodash/intersection';
import { MUTATION_ADD_SIDE, MUTATION_DELETE_SIDE } from './mutation-types';
import { useControlLayerStore } from '@/store-pinia/control-layer';

export default {
  [ACTION_PRODUCT_SWITCH_COMPOSITION]: (
    { state, commit, rootGetters },
    productData
  ) => {
    const productComposition = productData.composition;
    const newSides = Object.keys(productComposition.printPlates);
    const oldSides = Object.keys(state.composition.printPlates);

    // eslint-disable-next-line no-unused-vars
    for (const sideToAdd of difference(newSides, oldSides)) {
      commit(MUTATION_ADD_SIDE, {
        side: sideToAdd,
        printPlate: JSON.parse(
          JSON.stringify(productComposition.printPlates[sideToAdd])
        )
      });
    }
    // eslint-disable-next-line no-unused-vars
    for (const sideToRemove of difference(oldSides, newSides)) {
      commit(MUTATION_DELETE_SIDE, sideToRemove);
    }

    // eslint-disable-next-line no-unused-vars
    for (const sideToCheck of intersection(newSides, oldSides)) {
      let currentPrintStyle =
        state.composition.printPlates[sideToCheck].printStyle;
      let availablePrintStyles =
        productData.printAreas[sideToCheck].availablePrintStyles;

      // Check if the same print style is available in the new product's
      // print side currently looping. If available, nothing to do here.

      if (availablePrintStyles.includes(currentPrintStyle)) {
        continue;
      }

      // Get capabilities for the current print plate

      const printPlateCapabilites = rootGetters.getPrintPlateCapabilites(
        state.composition.printPlates[sideToCheck],
        sideToCheck
      );

      let newPrintStyle;
      let defaultPrintStyle =
        productData.printAreas[sideToCheck].defaultPrintStyle;

      // Usable print styles are styles that are available for the current
      // print side and are also capable for the current side's composition

      const usablePrintStyles = intersection(
        printPlateCapabilites,
        availablePrintStyles
      );

      if (0 === usablePrintStyles.length) {
        // No usable print styles are found. Pick the default one if it is
        // available in the usable styles. Otherwise pick the first one from
        // the available print styles instead of usable print styles

        newPrintStyle = availablePrintStyles.includes(defaultPrintStyle)
          ? defaultPrintStyle
          : availablePrintStyles[0];
      } else {
        // Some usable print styles are found. Pick the default one if it is
        // found. Otherwise pick the first one.

        newPrintStyle = usablePrintStyles.includes(defaultPrintStyle)
          ? defaultPrintStyle
          : usablePrintStyles[0];
      }

      const controlLayerStore = useControlLayerStore();
      controlLayerStore.updateSidePrintStyle(sideToCheck, newPrintStyle);
    }

    const controlLayerStore = useControlLayerStore();

    for (const plate in state.composition.printPlates) {
      state.composition.printPlates[plate].content.forEach(element => {
        controlLayerStore.elementAllowedToResizeByImageDimensions.add(
          element.uid
        );
      });
    }
  }
};
